// extracted by mini-css-extract-plugin
module.exports = {"container":"InPersonMeetingIcon_container__3olMR","icon":"InPersonMeetingIcon_icon__1Gr4Y","text":"InPersonMeetingIcon_text__3_ruR"};